import { TActivityHis } from "../../../context/ActivityProvider";
import { cn, formatdDate } from "../../../lib/utils";
import { IconMaterial } from "../../shared/iconMaterial/IconMaterial";
import { TooltipCell } from "../../table/TooltipCell";


type BodyTableProps = {
  id?: string | null;
  rows: TActivityHis[];
  isPagination?: boolean;
  isLoadingSendInvitation: boolean;
  onRowClick?: (id: string) => void;
  handleClickInviteButton: (id: string) => void;
};

export const BodyTableHisLogs = ({
  rows,
}: BodyTableProps): JSX.Element => {
  const baseCellClassName = cn(
    "p-[12px] typo-body-small-medium-14 text-black text-sm text-primary-light",
    "align-middle min-w-0",
  );

  return (
    <>
      {rows.map((activity, index) => {
        return (
          <tr key={index}>
            <td
              className={cn(
                baseCellClassName,
                "relative overflow-hidden"
              )}
            >
              <TooltipCell
                content={formatdDate(activity?.created_stamp) || '-'}
              />
              <div className="rounded-l-lg flex items-center group h-full w-full">
                <IconMaterial
                  filled
                  icon="chevron_right"
                  className="cursor-pointer hidden group-hover:block"
                  size={16}
                  iconColor="var(--tokens-text-secondary-text)" />
              </div>
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={activity?.user} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={activity?.exception} isTooltip={false}/>
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={activity?.traceback} isTooltip={false}/>
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={activity.response_status} />
            </td>

            <td className={cn(baseCellClassName)}>
              <TooltipCell content={activity.skipped_counter} />
            </td>
          </tr>
        );
      })}
    </>
  );
};
